<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-16 12:02:05
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-17 15:44:46
 * @FilePath: \zhucai_user\src\pages\member\child\info.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div v-loading="isloading" class="my-container">
    <div class="my-title">人员列表-证书</div>
    <div class="user-info">
      <div class="user-info-item">
        <div class="user-info-item-title">头像：</div>
        <div class="user-info-item-content">
          <div class="avatar">
            <img :src="info.Avatar" :onerror="userError" />
          </div>
        </div>
      </div>
      <div class="user-info-item">
        <div class="user-info-item-title">昵称：</div>
        <div class="user-info-item-content">{{ info.NiceName }}</div>
      </div>
      <div class="user-info-item">
        <div class="user-info-item-title">姓名：</div>
        <div class="user-info-item-content over-line1">{{ info.RealName }}</div>
      </div>
      <div class="user-info-item">
        <div class="user-info-item-title">性别：</div>
        <div class="user-info-item-content">{{ info.SexTxt }}</div>
      </div>
      <div class="user-info-item">
        <div class="user-info-item-title">手机账号：</div>
        <div class="user-info-item-content">{{ info.Phone }}</div>
      </div>
      <div class="user-info-item">
        <div class="user-info-item-title">身份证号：</div>
        <div class="user-info-item-content">{{ info.IDCard }}</div>
      </div>
      <div class="user-info-item">
        <div class="user-info-item-title">所属单位：</div>
        <div class="user-info-item-content over-line1">
          <el-tooltip placement="top">
            <div slot="content" class="tips">
              <div class="content">
                <p>{{ info.OrgnName }}</p>
              </div>
            </div>
            <template>
              <div class="content">
                <p>{{ info.OrgnName }}</p>
              </div>
            </template>
          </el-tooltip>
        </div>
      </div>
      <div class="user-info-item">
        <div class="user-info-item-title">身份：</div>
        <div class="user-info-item-content">{{ info.IdName }}</div>
      </div>
    </div>
    <div class="tit-info">证书列表</div>
    <div class="my-content">
      <div class="my-search-box">
        <div class="my-search">
          <i class="el-icon-search" @click="getList"></i>
          <input type="text" @keyup.enter="getList" v-model="getListData.CertName" placeholder="搜索证书分类名称" />
        </div>
        <el-select v-model="getListData.StatusID" placeholder="证书状态" clearable @change="getList">
          <el-option v-for="(it, i) in statusOptions" :key="i" :label="it.label" :value="it.value" />
        </el-select>
        <div class="my-dateRange">
          <el-date-picker v-model="getListData.StartDate" type="date" value-format="yyyy-MM-dd" placeholder="开始时间">
          </el-date-picker>
          <span class="heng">-</span>
          <el-date-picker v-model="getListData.EndDate" type="date" value-format="yyyy-MM-dd" placeholder="结束时间">
          </el-date-picker>
        </div>
        <el-button @click="getList" class="search-btn">搜索</el-button>
        <div class="right">
          <el-button @click="hanldExport" class="search-btn">导出</el-button>
        </div>
      </div>
      <el-table v-loading="isLoading" :data="tableData" class="mt20">
        <el-table-column prop="ClassifyName" label="证书类型" align="left" min-width="160">
        </el-table-column>
        <el-table-column prop="CertName" label="证书分类" align="center" min-width="160">
        </el-table-column>
        <el-table-column prop="CertLevel" label="证书级别" align="center" width="120">
        </el-table-column>
        <el-table-column prop="StatusTxt" label="证书状态" align="center" width="120">
        </el-table-column>
        <el-table-column prop="IsContinuingEducation" label="是否继续教育" width="180" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row.IsContinuingEducation == true ? "是" : "否"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="证书有效期" prop="ValidityYearTxt" width="150" align="center">
        </el-table-column>
        <el-table-column prop="ExpirationDateTxt" label="到期时间" width="220" align="center">
        </el-table-column>
      </el-table>
      <my-pagination :total="total" :pageSize="getListData.PageSize" v-model="getListData.PageIndex"></my-pagination>
      <div class="my-info-item mt30">
        <el-button class="submit-btn" @click="back"> 返回 </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  OrgnManage_GetUserCertList,
  OrgnManage_GetUserDetail,
} from "@/api/member";
import { getToken } from "@/util/auth";
import myPagination from "@/components/myPagination.vue";
/* eslint-disable */
export default {
  name: "certificate",
  components: { myPagination },
  data() {
    return {
      isloading: true,
      total: 0,
      tableData: [],
      statusOptions: [
        { label: "已失效", value: 0 },
        { label: "生效中", value: 1 },
      ],
      getListData: {
        CertName: "",
        StatusID: "",
        StartDate: "",
        EndDate: "",
        PageIndex: 1,
        PageSize: 10,
      },
      info: {
        Avatar: "",
        RealName: "",
        NickName: "",
        Sex: 1,
        IDCard: "",
        Phone: "",
        OrgList: [],
        IsManager: false,
        IsPartner: false,
        Password: "",
        IdName: "",
      },
    };
  },
  watch: {
    "getListData.PageIndex"() {
      this.getList();
    },
  },

  mounted() {
    this.getInfo();
    this.getList();
  },

  methods: {
    hanldExport() {
      const Token = getToken();
      const data = {
        ...this.getListData,
      };
      window.open(
        `${this.baseUrl}/pc/Member/OrgnManage_UserCertExport?Token=${Token}&&UserID=${this.$route.query.UserID}&CertName=${data.CertName}&StatusID=${data.StatusID}&StartDate=${data.StartDate}&EndDate=${data.EndDate}}`,
        "_blank"
      );
    },
    getList() {
      this.isLoading = true;
      const data = {
        ...this.getListData,
        UserID: this.$route.query.UserID,
      };
      OrgnManage_GetUserCertList(data).then((res) => {
        this.isLoading = false;
        this.total = res.count;
        this.tableData = res.data;
      });
    },
    back() {
      this.$router.push({ path: "/member/userList" });
    },
    getInfo() {
      const that = this;
      this.isloading = true;
      OrgnManage_GetUserDetail({
        UserID: this.$route.query.UserID,
      })
        .then((res) => {
          that.isloading = false;
          that.info = { ...that.info, ...res.data };
          let text = [];
          if (that.info.IsManager == true) {
            text.push("单位管理者");
          }
          if (that.info.IsPartner == true) {
            text.push("合作者");
          }
          that.info.IdName = text.join("/");
        })
        .catch(() => {
          this.isloading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.StudyProgress {
  font-weight: 900;
  font-size: 18px;
  color: #1d79ff;
}

.my-search-box {
  position: relative;

  .my-search {
    width: 300px;
  }

  .el-select {
    ::v-deep .el-input__inner {
      width: 201px;
      height: 47px;
      background: #f6f8fc;
      border-radius: 23px;
      border: 1px solid #e6e6e6;
    }
  }

  .el-date-editor {
    width: 180px;
    height: 47px;

    ::v-deep .el-input__inner {
      width: 180px;
      height: 47px;
      background: #f6f8fc;
      border-radius: 23px;
      border: 1px solid #e6e6e6;
    }
  }

  .right {
    position: absolute;
    right: 0;

    .search-btn {
      width: 141px;
    }
  }
}

.tit-info {
  padding: 25px;
  background: #ffffff;
  border-radius: 10px;
  font-size: 18px;
  margin-top: 20px;
  color: #333333;

  .label {
    font-size: 16px;
    color: #666666;
    margin-left: 50px;
  }

  .value {
    font-size: 16px;
    color: #333333;
  }
}

.avatar {
  cursor: pointer;
  margin-left: 10px;
  width: 50px;
  height: 50px;
  border-radius: 50%;

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}

.user-info {
  margin-top: 1px;
  padding: 25px;
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;

  .user-info-item {
    width: 25%;
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    .user-info-item-title {
      // width: 100px;
      font-weight: 400;
      font-size: 18px;
      text-align: left;
      color: #666666;
    }

    .user-info-item-content {
      max-width: 240px;
      color: #333333;
      font-weight: 400;
      font-size: 18px;
    }

    .bold {
      color: #333333;
    }

    .Amount {
      font-weight: bold;
      font-size: 20px;
      color: #e12a14;
    }
  }
}

.submit-btn {
  width: 144px;
  height: 52px;
  background: #1d79ff;
  border-radius: 6px;
  font-size: 18px;
  color: #ffffff;
}
</style>
